import type { InventoryItem } from '@/modules/inventory/types';

type RentalItemPickerProps = {
  items: InventoryItem[];
  selectedIds: string[];
  disabled?: boolean;
  onChange: (ids: string[]) => void;
};

export function RentalItemPicker({
  items,
  selectedIds,
  disabled = false,
  onChange,
}: RentalItemPickerProps) {
  if (items.length === 0) {
    return (
      <p className="auth-muted">
        No hay artículos alquilables disponibles (modo alquiler y estado
        disponible).
      </p>
    );
  }

  function toggle(id: string) {
    if (disabled) return;
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((x) => x !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  }

  return (
    <ul className="reservation-item-picker">
      {items.map((item) => (
        <li key={item.id}>
          <label className="auth-label auth-label--row">
            <input
              type="checkbox"
              disabled={disabled}
              checked={selectedIds.includes(item.id)}
              onChange={() => toggle(item.id)}
            />
            <span>
              <code>{item.sku}</code> — {item.name}
            </span>
          </label>
        </li>
      ))}
    </ul>
  );
}
